
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import NumeroObjet from '@/extend/classes/NumeroObjet';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeNumeroObjet' })

export default class storeNumeroObjet extends VuexModule {
  // States
  private reccords: NumeroObjet[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get numeroObjetLoading (): boolean {
    return this.dataLoading;
  }
  private get numeroObjetRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get numeroObjetLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewNumeroObjet() {
    return (): NumeroObjet => { 
      return this.getNumeroObjet(0, true);
    }
  }

  
  public get getNumeroObjet () {
    return (id: number, canCreate = false): NumeroObjet => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id NumeroObjet can't be 0")
        return new NumeroObjet();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new NumeroObjet();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            NumeroObjet.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromNumeroObjet(data.reccords[0] as NumeroObjet);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listNumeroObjet (): NumeroObjet[] {
    return this.reccords;
  }

  public get listConfigNumeroObjet (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mNumeroObjetRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mNumeroObjetClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mNumeroObjetLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mNumeroObjetLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(NumeroObjet.fromJson(reccord as NumeroObjet));
    })
    NumeroObjet.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mNumeroObjetConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mNumeroObjetCreated (obj: NumeroObjet): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareNumeroObjet(obj)) {
          api.fromNumeroObjet(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareNumeroObjet(obj)) {
            api.fromNumeroObjet(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mNumeroObjetUpdated (obj: NumeroObjet): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareNumeroObjet(obj)) {
          api.fromNumeroObjet(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mNumeroObjetDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerNumeroObjet (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.numeroObjetRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerNumeroObjet(this.numeroObjetCreated, this.numeroObjetUpdated, this.numeroObjetDeleted);
          this.mNumeroObjetRegistered();
        } else {
          setTimeout(() => resolve(this.registerNumeroObjet(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.numeroObjetLoading && !this.numeroObjetLoaded) {
          this.mNumeroObjetLoading(true);
          return NumeroObjet.list(filter)
            .then((data: ListData) => {
              this.mNumeroObjetLoaded(data);
              this.mNumeroObjetLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredNumeroObjet (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.numeroObjetLoading) {
        this.mNumeroObjetLoading(true);
        return NumeroObjet.list(filter)
          .then((data: ListData) => {
            this.mNumeroObjetLoaded(data);
            this.mNumeroObjetLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createNumeroObjet (obj: NumeroObjet): Promise<NumeroObjet> {
    return new Promise((resolve, reject) => {
      return NumeroObjet.fromJson(obj).createForStoreNumeroObjet()
        .then((reccords) => {
          this.mNumeroObjetCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateNumeroObjet (obj: NumeroObjet): Promise<NumeroObjet> {
    return new Promise((resolve, reject) => {
      return NumeroObjet.fromJson(obj).updateForStoreNumeroObjet()
        .then((reccords) => {
          this.mNumeroObjetUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteNumeroObjet (obj: NumeroObjet): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return NumeroObjet.fromJson(obj).deleteForStoreNumeroObjet()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mNumeroObjetDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private numeroObjetCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mNumeroObjetConfigUpdated(config)
    const obj = objConfig.obj as NumeroObjet;
    this.mNumeroObjetCreated(NumeroObjet.fromJson(obj));
  }

  @Action
  private numeroObjetUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mNumeroObjetConfigUpdated(config)
    const obj = objConfig.obj as NumeroObjet;
    this.mNumeroObjetUpdated(NumeroObjet.fromJson(obj));
  }

  @Action
  private numeroObjetDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as NumeroObjet;
    this.mNumeroObjetDeleted(obj.id);
  }
}
